export default "__VITE_ASSET__CKUa5dbg__"